import { fetchAuthSession } from 'aws-amplify/auth';

// Deliberately no throw on a dead session: callers omit the Authorization
// header and the backend 401s, instead of every request failing client-side
// (RTK Query console.errors those, flooding Datadog). undefined is
// definitive — Amplify rethrows transient network/service errors and only
// reports "no tokens" for real auth failures (TokenOrchestrator.handleErrors
// in @aws-amplify/auth).
export const getAccessToken = async (): Promise<string | undefined> => {
  const session = await fetchAuthSession();
  return session.tokens?.accessToken.toString();
};
